import {
  CheckCircleIcon,
  EllipsisHorizontalCircleIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/20/solid';
import { sshKeyStateToString } from '../../helpers/util';

interface SSHKeyStateBadgeProps {
  state: number;
}

export function SSHKeyStateBadge(props: SSHKeyStateBadgeProps) {
  return (
    <span className="flex items-center text-sm text-gray-500">
      {sshKeyStateToString(props.state) === 'Active' && (
        <CheckCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-green-400"
          aria-hidden="true"
        />
      )}
      {sshKeyStateToString(props.state) === 'Error' && (
        <ExclamationCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-red-400"
          aria-hidden="true"
        />
      )}
      {sshKeyStateToString(props.state) === 'Pending' && (
        <EllipsisHorizontalCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
          aria-hidden="true"
        />
      )}
      {sshKeyStateToString(props.state)}
    </span>
  );
}
